export default "__VITE_ASSET__7sEK0PcF__"